// Keep the customer boundary aligned with Scroller.Core.PirdyDeviceId.
// Existing eight-digit IDs remain valid during the production-batch transition.
export const pirdyDeviceIdPattern = "PIRDY-[0-9]{8}(-[0-9]{2,17})?";
export const pirdyDeviceIdMaximumLength = 32;

export function isValidPirdyDeviceId(value) {
  if (typeof value !== "string" || value.length > pirdyDeviceIdMaximumLength) return false;
  if (/^PIRDY-[0-9]{8}$/.test(value)) return true;
  const match = /^PIRDY-([0-9]{4})([0-9]{2})([0-9]{2})-([0-9]{2,17})$/.exec(value);
  if (!match) return false;
  const [, yearText, monthText, dayText, serial] = match;
  const year = Number(yearText), month = Number(monthText), day = Number(dayText);
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return year >= 1 && month >= 1 && month <= 12 && day >= 1 && day <= days[month - 1] &&
    serial !== "00" && (serial.length === 2 || serial[0] !== "0");
}

export function normalizePirdyDeviceId(value) {
  const normalized = typeof value === "string" ? value.trim().toUpperCase() : "";
  if (!isValidPirdyDeviceId(normalized)) {
    const error = new Error("Enter the Device ID exactly as shown on your Pirdy, for example PIRDY-20261023-01.");
    error.customerSafe = true;
    throw error;
  }
  return normalized;
}
